<!-- video section start -->
<div class="background-video">
  <video autoplay muted loop id="video-bg">
    <source
      src="assets/v-4-icone/videos/-dd65-44a7-b048-bd9de5358ecd.mp4"
      type="video/mp4"
    />
  </video>
  <div class="custom-overlay"></div>
  <!-- video section end -->

  <div
    class="d-flex justify-content-center align-items-center flex-column h-100vh banner 11111"
  >
    <!-- <div #air id="air" class='air kenburns-top'></div> -->
    <div #air id="air" class="air"></div>
    <h1 class="main-heading V4-Z-INDEX-1">
      {{ "Knowledge gate" | translator }}
    </h1>
    <p class="mini-heading V4-Z-INDEX-1">
      {{ "Knowledge" | translator }} | {{ "Training" | translator }} |
      {{ "Development" | translator }}
    </p>

    <div
      class="v4-login-card p-4 w-full lg:w-6 V4-Z-INDEX-1"
      style="max-height: 100vh; overflow: auto"
    >
      <div class="text-center mb-5">
        <img
          src="../../../assets/v-4-icone/Vector.png"
          alt="Image"
          height="50"
          class="mb-3"
        />
        <h3 class="heading v4-color-white">
          {{ "Create an account" | translator }}
        </h3>
      </div>
      <app-signup-form [type]="'SIGNUP'"></app-signup-form>
    </div>
    <p class="text-center pt-3 V4-Z-INDEX-1">
      <span class="white">{{ "do you have an account?" | translator }}</span>
      &nbsp;&nbsp;
      <span routerLink="/login" class="bottom-btns">
        {{ "Login" | translator }}
      </span>
    </p>
  </div>
</div>
